import { CreditEngineFormValues } from "@/models/consignado/criteriaEngine.model";
import { FormikErrors } from "formik";

export function getFormError(
  errors: FormikErrors<CreditEngineFormValues>,
  path: (string | number)[]
): string | undefined {
  let current: any = errors;

  for (const key of path) {
    if (current == null) return undefined;
    if (typeof current === "string") return current;
    current = current[key];
  }

  return typeof current === "string" ? current : undefined;
}
